import React from 'react';
import { Link } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import { FiArrowRight, FiFlag } from 'react-icons/fi';
import Reveal from '../fx/Reveal';
import ShapeGrid from '../fx/ShapeGrid';
import FloatingShapes from '../fx/FloatingShapes';

const CTA = () => {
    return (
        <section className="relative text-white px-6 md:px-16 py-24 overflow-hidden bg-[#08090f]">
            <ShapeGrid density={48} interactive={false} />
            <FloatingShapes />
            <div className="absolute inset-0 spotlight" aria-hidden="true" />

            <Reveal className="relative max-w-3xl mx-auto text-center">
                <span className="pill tag inline-flex mb-5">READY?</span>
                <h2 className="font-display text-4xl md:text-6xl font-bold mb-5 leading-tight">
                    Boost your <span className="text-gradient-red">cyber defense</span>.
                </h2>
                <p className="text-gray-300 mb-8 text-lg">
                    Join orgs across Indonesia who trust SiberLab ID for hands-on training,
                    elite red-team engagements, and turn-key CTF event ops.
                </p>
                <div className="flex flex-wrap gap-3 justify-center">
                    <Link to="contact" smooth duration={600} offset={-40} className="btn-primary cursor-pointer">
                        Get started <FiArrowRight />
                    </Link>
                    <RouterLink to="/services/ctf-vendor" className="btn-ghost">
                        <FiFlag /> Run a CTF with us
                    </RouterLink>
                </div>
            </Reveal>
        </section>
    );
};

export default CTA;
